import { Col, Container, Row } from "react-bootstrap";
import vamosjuntos from "../../assets/img/logo.png";
import web from "../../assets/img/web.png";
import yt from "../../assets/img/yt.png";
import fb from "../../assets/img/fb.png";
import ig from "../../assets/img/ig.png";
import WhatsAppFlotante from "../WhatsAppFlotante/WhatsAppFlotante";
import { persistUtmsFromUrl } from "../../utils/utm";

const Footer = () => {
  persistUtmsFromUrl();

  return (
    <>
      <Container fluid className="footer pb-4" name="footer">
        <Row>
          <Col>
            <Container>
              <Row>
                <Col md={12} xs={12} className="mx-auto">
                  <Row className="d-flex justify-content-between flex-md-row flex-column">
                    <Col className="d-flex justify-content-md-between justify-content-center flex-md-row flex-column">
                      <div className="text-md-start text-center">
                        <img src={vamosjuntos} className="img-fluid" alt="Montironi" />
                      </div>
                    </Col>

                    <Col className="d-flex justify-content-md-end justify-content-center  flex-md-row flex-column">
                      <div className="d-flex justify-content-md-between justify-content-center align-items-center align-content-center flex-md-row flex-column pt-md-0 pt-3">
                        <p className="pt-3 pe-md-3 txt-seguinos">Seguinos en:</p>
                      </div>

                      <div className="d-flex justify-content-md-start justify-content-center align-items-center align-content-center ">
                        <div className="p-md-2">
                          <a href="https://www.montironi.com/" target="_blank" rel="noreferrer">
                            <img src={web} />
                          </a>
                        </div>
                        <div className="p-md-2">
                          <a href="https://www.facebook.com/montironiok" target="_blank" rel="noreferrer">
                            <img src={fb} />
                          </a>
                        </div>
                        <div className="p-md-2">
                          <a href="https://www.instagram.com/montironiok/g" target="_blank" rel="noreferrer">
                            <img src={ig} />
                          </a>
                        </div>
                        <div className="p-md-2">
                          <a
                            href="https://www.youtube.com/channel/UCeDr83GQGvKAMOWso3fjS9Q"
                            target="_blank"
                            rel="noreferrer"
                          >
                            <img src={yt} />
                          </a>
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <p className="txt-seguinos pt-md-3 pt-5 text-md-start text-center ">
                        El contenido de este sitio web no debe ser considerado oferta y puede ser actualizado de forma
                        parcial o total sin previo aviso.
                      </p>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Container>
          </Col>
        </Row>
      </Container>
      <Container fluid className="footerWhite">
        <Row>
          <Col>
            <h4>
              Ⓒ Montironi Automotores. <br className="d-block d-md-none" /> Todos los derechos reservados
            </h4>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Footer;

